export enum OfflineDownloadStatusEnum {
  DEFAULT,
  DONE,
  IN_PROGRESS,
  ERROR
}
